<template>
  <div>

    <div class="d-flex justify-content-center mt-2">
        <p id="title-term-Venda">TERMO DE AUTORIZAÇÃO PARA REEMBOLSO DE VIAGEM</p>
    </div>

    <div v-if="BoolMotivoViagem == false">
        <div class="d-flex justify-content-center">
            <div class="mt-2" id="box-text">
                <p id="info-desp">Eu, <strong>{{dataPerson.nome}} </strong> com o código <strong>{{dataPerson.codigo}}</strong>, funcionário da empresa
                    <strong>{{'Zopone'}}</strong>, autorizo a descontar na folha de pagamento, a
                    quantia de <strong>{{total}}</strong>, referente à despesa de viagem.</p>
            </div>
        </div>
        <div class="d-flex input-check">
            <input type="checkbox" v-model="checked">
            <p class="mt-3 pl-1">Declaro de lido o termo acima e aceito todas as suas condições!</p>
        </div>
    </div>

    <div class="d-flex padding" v-if="BoolMotivoViagem == true">
        <div class="termo-cleck">
            <div class="d-flex justify-content-center">
                <div class="mt-2" id="box-text">
                    <p id="info-desp">Eu, <strong>{{dataPerson.nome}} </strong> com o código <strong>{{dataPerson.codigo}}</strong>, funcionário da empresa
                            <strong>{{'Zopone'}}</strong>, solicito a venda da minha baixada na quantia de <strong>{{total}}</strong>. O valor solicitado é um acordo entre o empregado e o empregador, possui natureza indenizatória, e não será
                            incorporado ao salário para reflexos trabalhistas.</p>
                </div>
            </div>

            <div class="d-flex input-check">
                <input type="checkbox" v-model="checked">
                <p class="mt-3 pl-1">Declaro lido o termo acima e aceito todas as suas condições!</p>
            </div>
        </div>

        <div class="Assinatura">
            <div class="d-flex justify-content-center mt-2">
                <div v-if="!hasFile" class="input-import" @click="addImg">
                    <div>
                        <div class="d-flex justify-content-center mb-3">
                            <i class="fas fa-cloud-download-alt" style="font-size: 80px"></i>
                        </div>
                        <p id="font-pdf">Baixe o PDF acima,adicione a assinatura e insira aqui o documento assinado!</p>
                    </div>
                </div>
                <div v-else class="input-with-file">
                    <div @click="removeFile" id="remove-file">X</div>
                    <i class="fas fa-file-pdf" style="font-size: 80px;color: #028849"></i>
                    <div id="footer-file">{{nameFile}}</div>
                </div>
            </div>

            <div class="d-flex justify-content-center mt-2">
                <button class="btn-dowload" @click="print()"><i class="fas fa-file-pdf"></i> BAIXAR PDF</button>
            </div>
        <input type="file" @change="setValueInput" style="visibility:hidden" id="input-hidden" accept="application/pdf  ">
      </div>
    </div>

    </div>

</template>

<script>
import TermTravekModal from './TermTravekModal'
export default TermTravekModal
</script>

<style scoped>
#title-term-Venda {
    font-size: 17px;
    font-weight: bold;
    color: #025e33;
    padding-top: 1rem;
    text-align: center;
}
.padding{
    padding: 0 3rem 0 3rem;
}
.Assinatura{
    width: 50%;
}
.termo-cleck{
    width: 50%;
}
 .input-check{
    padding-left: 15%;
 }
  #box-text{
    width: 70%;
    height: 250px;
    border-radius: 10px;
    display: flex;
    padding: 35px;
    justify-content: center;
    align-items: center;
    border: 1px solid black;
  }
  #info-desp{
    font-size: 16px;
  }
  #title-term{
    font-size: 22px;
    font-weight: bold;
    color: #025e33;
  }
  #font-pdf{
    font-size: 15px;
    text-align: center;
    font-weight: bold;
}
.btn-dowload{
    width: 70%;
    margin-bottom: 1.5rem;
    height: 45px;
    border: none;
    background: #025e33;
    border-radius: 10px;
    color: white;
    font-size: 16px;
}
.btn-dowload:hover{
    background: #028849;

}
.input-with-file{
    width: 70%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    height: 250px;
    position: relative;
    border-radius: 10px;
    border: 1px solid #028849;
}
#remove-file{
    height: 65px;
    width: 65px;
    border-radius: 0 10px 0 50%;
    top: 0;
    right: 0;
    position: absolute;
    color: white;
    font-size: 24px;
    font-weight: bold;
    background: red;
    display: flex;
    justify-content: center;
    align-items: center;
}
#footer-file{
    position: absolute;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    color: white;
    background: #028849;
    border-radius: 0 0 10px 10px;
    font-size: 24px;
    width: 100%;
}
#remove-file:hover{
    background: rgb(182, 1, 1);
}
.input-import{
    width: 70%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    height: 250px;
    border-radius: 10px;
    border: 1px dashed black;
    padding: 0 1rem 0 1rem;
}

</style>



// WEBPACK FOOTER //
// src/views/private/travelreimbursement/components/TermTravekModal/TermTravekModal.vue